import { createSelector } from 'reselect';
import mappings from './mappings';

export const combinedColumnsSelector = createSelector(
    state => state.webJobs.columns,
    columns => columns.map(column => ({
        ...column,
        ...mappings.find(col => col.id === column.id)
    }))
);

export const getDefaultFilters = state => (
    state.webJobs.defaultFilters
);

export const getLastUpdated = state => (
    state.webJobs.lastUpdated
);

export const getFilterDefinitions = state => (
    state.webJobs.filterDefinitions
);

export const getInitialised = state => (
    state.webJobs.initialised
);

export const getLoading = state => (
    state.webJobs.loading
);

export const getRows = state => (
    state.webJobs.rows
);

export const getLoadRequestMappings = state => (
    state.webJobs.loadRequestMappings
);

export const getCurrentServerFilters = state => (
    state.webJobs.currentServerFilters
);

export const getDateFrom = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.from;
        }
    }
    return null;
};

export const getDateTo = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.to;
        }
    }
    return null;
};

export const getDefaultSort = state => (
    state.webJobs.gridSorting
);
